export const isEntryOmitted = (device, locale) => (entry) => {
  if (!entry.omit) {
    return false;
  }

  const { devices = [], locales = [] } = entry.omit;

  return devices.includes(device) || locales.includes(locale);
};
